import { lazyWithRetry } from "./lazyWithRetry";

// Transaction Management Features
export const TransactionsListTable = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionsListTable").then(
    (m) => ({
      default: m.TransactionsListTable
    })
  )
);

export const TransactionEditForm = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionEditForm").then(
    (m) => ({
      default: m.TransactionEditForm
    })
  )
);

export const TransactionEditFormWrapper = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionEditForm").then(
    (m) => ({
      default: m.TransactionEditFormWrapper
    })
  )
);

export const TransactionComments = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionComments").then(
    (m) => ({
      default: m.TransactionComments
    })
  )
);

export const TransactionQueries = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionQueries").then((m) => ({
    default: m.TransactionQueries
  }))
);

export const TransactionSummary = lazyWithRetry(() =>
  import("@/components/features/transactions/TransactionSummary").then((m) => ({
    default: m.TransactionSummary
  }))
);

export const BulkPublishModal = lazyWithRetry(() =>
  import("@/components/features/transactions/BulkPublishModal").then((m) => ({
    default: m.BulkPublishModal
  }))
);

export const BulkDeleteModal = lazyWithRetry(() =>
  import("@/components/features/transactions/BulkDeleteModal").then((m) => ({
    default: m.BulkDeleteModal
  }))
);

// Reconciliation Features
export const ReconciliationList = lazyWithRetry(() =>
  import("@/components/features/reconciliation/ReconciliationList").then(
    (m) => ({
      default: m.ReconciliationList
    })
  )
);

export const MatchStatement = lazyWithRetry(() =>
  import("@/components/features/reconciliation/MatchStatement").then((m) => ({
    default: m.MatchStatement
  }))
);

export const ReconStatementList = lazyWithRetry(() =>
  import("@/components/features/reconciliation/ReconStatementList").then(
    (m) => ({
      default: m.ReconStatementList
    })
  )
);

export const ReconciliationStatementListTable = lazyWithRetry(() =>
  import(
    "@/components/features/reconciliation/ReconciliationStatementListTable"
  ).then((m) => ({
    default: m.ReconciliationStatementListTable
  }))
);

export const ReconStatementUploadEditForm = lazyWithRetry(() =>
  import(
    "@/components/features/reconciliation/ReconStatementUploadEditForm"
  ).then((m) => ({
    default: m.ReconStatementUploadEditForm
  }))
);

// Dashboard Features
export const ClientDashboard = lazyWithRetry(() =>
  import("@/components/features/clientDashboard/ClientDashboard").then((m) => ({
    default: m.ClientDashboard
  }))
);

export const CompanyDashboard = lazyWithRetry(() =>
  import("@/components/features/companyDashboard/CompanyDashboard").then(
    (m) => ({
      default: m.CompanyDashboard
    })
  )
);

// Settings Features
export const ConnectBank = lazyWithRetry(() =>
  import("@/components/features/settings/ConnectBank").then((m) => ({
    default: m.ConnectBank
  }))
);

// Document Processing Features
export const DocumentIngestForm = lazyWithRetry(() =>
  import("@/components/features/transactions/DocumentIngestForm").then((m) => ({
    default: m.DocumentIngestForm
  }))
);

export const DuplicatesView = lazyWithRetry(() =>
  import("@/components/features/transactions/DuplicatesView").then((m) => ({
    default: m.DuplicatesView
  }))
);
